"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateNodeType = void 0;
var StateNodeType;
(function (StateNodeType) {
    StateNodeType["Auto"] = "auto";
    StateNodeType["Atomic"] = "atomic";
    StateNodeType["Compound"] = "compound";
    StateNodeType["Parallel"] = "parallel";
    StateNodeType["Final"] = "final";
    StateNodeType["History"] = "history";
})(StateNodeType = exports.StateNodeType || (exports.StateNodeType = {}));
//# sourceMappingURL=state-node-type.js.map